import { ACTUAL_ESTABLISHMENT } from "../reducers/establishment"


export const actualEstablishment = (establishment: any) => {
    return {
        type: ACTUAL_ESTABLISHMENT,
        payload: establishment
    }
}